export const entryFormShowPath = (status, id) =>
  status === 'REVISADO'
    ? `/CheckFormEntry?Number=${id}`
    : `/FormShow?FormEntry=${id}`

export const entryCorrectionShowPath = (status, id) =>
  status === 'REVISADO'
    ? `/CheckCorrectEntry?ShowEntry=${id}`
    : `/FormCorrection?ShowEntry=${id}`

export const exitFormShowPath = (status, id) =>
  status === 'REVISADO'
    ? `/CheckForm?Number=${id}`
    : `/FormShowExit?ExitNumber=${id}`

export const exitCorrectionShowPath = (status, id) =>
  status === 'REVISADO'
    ? `/CheckCorrectOutput?ShowOutput=${id}`
    : `/FormCorrectionOutput?ShowOutput=${id}`
